import React from "react";

interface IProps {
  height?: number;
  width?: number;
  svgFill?: string;
  pathFill?: string;
}

const defaultHeight = "18px";
const defaultWidth = "18px";

export const PlusIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3V21"
        stroke={pathFill}
        stroke-width="1.5"
        stroke-linecap="round"
      />
      <path
        d="M3 12L21 12"
        stroke={pathFill}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const UploadDocIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 4.5H16C17.933 4.5 19.5 6.067 19.5 8V11.1213C19.5 11.1643 19.4992 11.2072 19.4976 11.25H17C13.8244 11.25 11.25 13.8244 11.25 17V19.5H8C6.067 19.5 4.5 17.933 4.5 16V8C4.5 6.067 6.067 4.5 8 4.5ZM12.75 19.3484C13.3689 19.1601 13.9303 18.8018 14.3652 18.3048L18.634 13.4261C18.8159 13.2182 18.9712 12.9911 19.098 12.75H17C14.6528 12.75 12.75 14.6528 12.75 17V19.3484ZM16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H11.7312C13.173 21 14.5446 20.3776 15.494 19.2925L19.7629 14.4138C20.5604 13.5024 21 12.3324 21 11.1213V8C21 5.23858 18.7614 3 16 3Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const CameraIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.19354 4.53576C9.38337 4.06119 9.843 3.75 10.3541 3.75H13.646C14.1571 3.75 14.6168 4.06119 14.8066 4.53576L15.3037 5.77854C15.4176 6.06329 15.6934 6.25 16.0001 6.25H18C19.7949 6.25 21.25 7.70507 21.25 9.5V16.5C21.25 18.2949 19.7949 19.75 18 19.75H6C4.20507 19.75 2.75 18.2949 2.75 16.5V9.5C2.75 7.70508 4.20508 6.25 6 6.25H8.00007C8.30675 6.25 8.58253 6.06329 8.69643 5.77854L9.19354 4.53576ZM10.3541 2.25C9.22965 2.25 8.21845 2.93462 7.80082 3.97868L7.49229 4.75H6C3.37665 4.75 1.25 6.87665 1.25 9.5V16.5C1.25 19.1234 3.37665 21.25 6 21.25H18C20.6234 21.25 22.75 19.1234 22.75 16.5V9.5C22.75 6.87665 20.6234 4.75 18 4.75H16.5078L16.1993 3.97868C15.7817 2.93461 14.7705 2.25 13.646 2.25H10.3541ZM15.5 12.25C15.5 14.183 13.933 15.75 12 15.75C10.067 15.75 8.5 14.183 8.5 12.25C8.5 10.317 10.067 8.75 12 8.75C13.933 8.75 15.5 10.317 15.5 12.25ZM17 12.25C17 15.0114 14.7614 17.25 12 17.25C9.23858 17.25 7 15.0114 7 12.25C7 9.48858 9.23858 7.25 12 7.25C14.7614 7.25 17 9.48858 17 12.25Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const MicIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.6048 5.12903V12.5154C14.6048 13.9674 13.4278 15.1444 11.9758 15.1444C10.5238 15.1444 9.34677 13.9674 9.34677 12.5154V5.12903C9.34677 3.67706 10.5238 2.5 11.9758 2.5C13.4278 2.5 14.6048 3.67706 14.6048 5.12903ZM7.84677 5.12903C7.84677 2.84863 9.69541 1 11.9758 1C14.2562 1 16.1048 2.84863 16.1048 5.12903V12.5154C16.1048 14.7958 14.2562 16.6444 11.9758 16.6444C9.69541 16.6444 7.84677 14.7958 7.84677 12.5154V5.12903ZM11.9758 18.8278C8.36048 18.8278 5.5 16.0614 5.5 12.7333H4C4 16.7205 7.20394 19.9356 11.2258 20.2945V23H12.7258V20.2945C16.7477 19.9356 19.9516 16.7205 19.9516 12.7333H18.4516C18.4516 16.0614 15.5911 18.8278 11.9758 18.8278Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const VideoIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.75 4C2.12665 4 0 6.12665 0 8.75V16.0643C0 18.6876 2.12665 20.8143 4.75 20.8143H13.0214C15.6084 20.8143 17.7124 18.7461 17.7702 16.173L20.6899 18.4439C21.8394 19.3379 23.5143 18.5188 23.5143 17.0625V7.75178C23.5143 6.29552 21.8394 5.47636 20.6899 6.37042L17.7702 8.64128C17.7124 6.06814 15.6084 4 13.0214 4H4.75ZM17.7714 10.5406V14.2737L21.6108 17.2598C21.775 17.3876 22.0143 17.2705 22.0143 17.0625V7.75178C22.0143 7.54374 21.775 7.42672 21.6108 7.55444L17.7714 10.5406ZM16.2714 9.807V8.75C16.2714 6.95508 14.8164 5.5 13.0214 5.5H4.75C2.95508 5.5 1.5 6.95508 1.5 8.75V16.0643C1.5 17.8592 2.95508 19.3143 4.75 19.3143H13.0214C14.8164 19.3143 16.2714 17.8592 16.2714 16.0643V15.0073V14.6405V10.1738V9.807Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const PhoneIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#17142A",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.87926 6.23916L6.79599 3.89549C6.30593 3.34418 5.53358 3.0864 4.90183 3.46718C4.56672 3.66917 4.24875 3.91304 3.95464 4.17368C2.4855 5.4756 2.17067 7.58299 2.87001 9.4172C3.6023 11.3379 4.87967 13.8797 7 16C10.3395 19.3395 14 21 17 21C18.8955 21 20.292 20.0643 20.7953 18.932C21.0421 18.3768 20.7238 17.7791 20.2494 17.3995L17.2494 14.9995C16.519 14.4152 15.481 14.4152 14.7506 14.9995L14.0374 15.5701C13.7137 15.829 13.2621 15.8629 12.9101 15.644C10.603 14.2092 9.47384 12.948 8.27452 10.5625C8.10262 10.2206 8.15173 9.81034 8.3908 9.5115L8.94618 8.81728C9.55491 8.05636 9.52665 6.96748 8.87926 6.23916Z"
        stroke={pathFill}
        stroke-width="1.5"
      />
    </svg>
  );
};

export const PdfIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
  svgFill = "none",
  pathFill = "#F3464A",
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox={`0 0 24 24`}
      fill={svgFill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 0.5H2.5C1.83696 0.5 1.20107 0.763392 0.732233 1.23223C0.263392 1.70107 0 2.33696 0 3V23C0 23.663 0.263392 24.2989 0.732233 24.7678C1.20107 25.2366 1.83696 25.5 2.5 25.5H17.5C18.163 25.5 18.7989 25.2366 19.2678 24.7678C19.7366 24.2989 20 23.663 20 23V8L12.5 0.5ZM6.8725 18.2375C6.48625 18.6 5.91625 18.7625 5.2525 18.7625C5.1238 18.7639 4.99516 18.7564 4.8675 18.74V20.5225H3.75V15.6025C4.25432 15.5273 4.7639 15.493 5.27375 15.5C5.97 15.5 6.465 15.6325 6.79875 15.8988C7.11625 16.1512 7.33125 16.565 7.33125 17.0525C7.33 17.5425 7.1675 17.9563 6.8725 18.2375ZM11.6313 19.9312C11.1063 20.3675 10.3075 20.575 9.33125 20.575C8.74625 20.575 8.3325 20.5375 8.05125 20.5V15.6038C8.55575 15.5301 9.06517 15.4954 9.575 15.5C10.5212 15.5 11.1362 15.67 11.6163 16.0325C12.135 16.4175 12.46 17.0312 12.46 17.9125C12.46 18.8663 12.1112 19.525 11.6313 19.9312ZM16.25 16.4625H14.335V17.6012H16.125V18.5188H14.335V20.5237H13.2025V15.5375H16.25V16.4625ZM12.5 9.25H11.25V3L17.5 9.25H12.5Z"
        fill={pathFill}
      />
    </svg>
  );
};

export const ExcelIcon: React.FC<IProps> = ({
  height = defaultHeight,
  width = defaultWidth,
}) => {
  return (
    <svg
      width="20"
      height="28"
      viewBox="0 0 20 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.9884 6.85172C16.3234 6.85107 15.6858 6.58661 15.2156 6.1164C14.7454 5.64618 14.4809 5.00863 14.4803 4.34365V0.861328H3.27435C2.84441 0.861169 2.41864 0.945698 2.02139 1.11012C1.62414 1.27453 1.26317 1.51562 0.959102 1.81957C0.655034 2.12352 0.413829 2.4844 0.249263 2.88159C0.0846971 3.27878 -1.21632e-07 3.70451 0 4.13444V23.8656C-1.21632e-07 24.2956 0.0846971 24.7213 0.249263 25.1185C0.413829 25.5157 0.655034 25.8766 0.959102 26.1806C1.26317 26.4845 1.62414 26.7256 2.02139 26.8899C2.41864 27.0544 2.84441 27.1389 3.27435 27.1388H16.7269C17.595 27.1388 18.4275 26.7939 19.0413 26.1801C19.6552 25.5663 20 24.7337 20 23.8656V6.85172H16.9884Z"
        fill="#009DE2"
      />
      <path
        d="M19.9999 6.85172H16.9883C16.3233 6.85107 15.6857 6.58661 15.2155 6.1164C14.7453 5.64618 14.4808 5.00863 14.4802 4.34365V0.861328L19.9999 6.85172Z"
        fill="#93D7F5"
      />
      <path
        d="M15.8852 11.0453H3.32783C3.20718 11.0453 3.09149 10.9974 3.00617 10.9121C2.92086 10.8267 2.87293 10.711 2.87293 10.5904C2.87277 10.5306 2.88442 10.4713 2.90721 10.4159C2.93 10.3606 2.96348 10.3103 3.00574 10.2679C3.048 10.2256 3.09819 10.192 3.15346 10.169C3.20873 10.1461 3.26799 10.1343 3.32783 10.1343H15.8852C16.0062 10.1343 16.1221 10.1823 16.2077 10.2679C16.2932 10.3534 16.3413 10.4694 16.3413 10.5904C16.3409 10.7112 16.2927 10.8269 16.2072 10.9122C16.1217 10.9974 16.0059 11.0453 15.8852 11.0453Z"
        fill="#E5F7FF"
      />
      <path
        d="M15.8852 13.7665H3.32783C3.20718 13.7665 3.09149 13.7186 3.00617 13.6333C2.92086 13.5479 2.87293 13.4322 2.87293 13.3116C2.87277 13.2517 2.88442 13.1925 2.90721 13.1372C2.93 13.0818 2.96348 13.0315 3.00574 12.9891C3.048 12.9468 3.09819 12.9131 3.15346 12.8902C3.20873 12.8673 3.26799 12.8555 3.32783 12.8555H15.8852C16.0062 12.8555 16.1221 12.9035 16.2077 12.989C16.2932 13.0746 16.3413 13.1907 16.3413 13.3116C16.3409 13.4324 16.2927 13.548 16.2072 13.6333C16.1217 13.7186 16.0059 13.7665 15.8852 13.7665Z"
        fill="#E5F7FF"
      />
      <path
        d="M15.8852 16.4872H3.32783C3.26799 16.4872 3.20873 16.4754 3.15346 16.4524C3.09819 16.4295 3.048 16.3959 3.00574 16.3535C2.96348 16.3112 2.93 16.2608 2.90721 16.2055C2.88442 16.1502 2.87277 16.0909 2.87293 16.0311C2.87293 15.9104 2.92086 15.7947 3.00617 15.7094C3.09149 15.6241 3.20718 15.5762 3.32783 15.5762H15.8852C16.0059 15.5762 16.1217 15.6241 16.2072 15.7094C16.2927 15.7946 16.3409 15.9103 16.3413 16.0311C16.3413 16.1521 16.2932 16.268 16.2077 16.3536C16.1221 16.4392 16.0062 16.4872 15.8852 16.4872Z"
        fill="#E5F7FF"
      />
      <path
        d="M10.9298 19.2084H3.32783C3.26799 19.2084 3.20873 19.1966 3.15346 19.1736C3.09819 19.1507 3.048 19.117 3.00574 19.0747C2.96348 19.0324 2.93 18.982 2.90721 18.9267C2.88442 18.8715 2.87277 18.8121 2.87293 18.7523C2.87293 18.6316 2.92086 18.5159 3.00617 18.4306C3.09149 18.3453 3.20718 18.2974 3.32783 18.2974H10.9298C11.0505 18.2974 11.1662 18.3453 11.2515 18.4306C11.3368 18.5159 11.3848 18.6316 11.3848 18.7523C11.3849 18.8121 11.3733 18.8715 11.3505 18.9267C11.3277 18.982 11.2942 19.0324 11.2519 19.0747C11.2097 19.117 11.1595 19.1507 11.1042 19.1736C11.049 19.1966 10.9897 19.2084 10.9298 19.2084Z"
        fill="#E5F7FF"
      />
    </svg>
  );
};
